<template>
    <div hidden></div>
</template>

<script>
  import pdfMake from 'pdfmake/build/pdfmake';
  import pdfFonts from 'pdfmake/build/vfs_fonts';
  import html2canvas from 'html2canvas';
  import {EMPTY_APPLYINGEFFICIENCY_IMG} from '../../reports/pdfConstants';
  import lang from '../../../lang/translator';
  import forEach from 'lodash/forEach';

  export default {
    props: {
      'efficiencyList': {
        type: [Array, Object],
        default() {
          return [];
        },
      },
      'client': {
        type: [String],
        default() {
          return [];
        },
      },
    },
    data() {
      return {
      };
    },
    components: {
    },

    computed: {
    },

    methods: {
      generate () {
        let that = this;
        let pdfName = lang.get('report.info_client');
        if (this.client) {
          pdfName = lang.get('report.info_client') + '_' + this.client;
        }

        //Filters
        html2canvas(
          document.querySelector('#pdf-filers'),
          {allowTaint: true, useCORS:true, scale: 2}
        ).then(canvas => {
          let filtersImg = canvas.toDataURL('image/png');

          //Client Table
          html2canvas(
            document.querySelector('#pdf-client-table'),
            {allowTaint: true, useCORS:true, scale: 2}
          ).then(canvas => {
            let clientsImg = canvas.toDataURL('image/png');

            //Ub - Appeals
            html2canvas(
              document.querySelector('#pdf-ub'),
              {allowTaint: true, useCORS:true, scale: 2}
            ).then(canvas => {
              let ubImg = canvas.toDataURL('image/png');

              //Ub - Appeals
              html2canvas(
                document.querySelector('#pdf-appeals'),
                {allowTaint: true, useCORS:true, scale: 2}
              ).then(canvas => {
                let appealsImg = canvas.toDataURL('image/png');

              html2canvas(
                document.querySelector('#pdf-filers'),
                {allowTaint: true, useCORS:true, scale: 2}
              ).then(canvas => {
                let efficiencyList = [];
                let emptyEfficiencyList = [];

                for (let i = 0; i < this.efficiencyList.length; i++) {
                  if (this.efficiencyList[i].daySessions.length > 0) {
                    let daySessions = this.efficiencyList[i].daySessions.filter(function (item) {
                      return item.noData === false;

                    })
                    if (daySessions.length > 0) {
                      let domEfficiency = document.getElementById('slide_' + i)
                      html2canvas(
                        domEfficiency,
                        {allowTaint: true, useCORS: true, scale: 2}
                      ).then(canvas => {
                        let efficiencyImg = canvas.toDataURL('image/png');
                        efficiencyList.push({
                          source: efficiencyImg,
                          title: this.efficiencyList[i].skillFieldName
                        })
                      });
                    } else {
                      emptyEfficiencyList.push({
                        title: this.efficiencyList[i].skillFieldName
                      })
                    }
                  } else {
                    emptyEfficiencyList.push({
                      title: this.efficiencyList[i].skillFieldName
                    })
                  }
                }

                html2canvas(
                  document.querySelector('#pdf-filers'),
                  {allowTaint: true, useCORS:true}
                ).then(canvas => {
                  pdfMake.vfs = pdfFonts.pdfMake.vfs;
                  let docDefinition = {
                    pageSize: 'A4',
                    pageOrientation: 'portrait',
                    pageMargins: [ 20, 30, 20, 20 ],
                    content: that.getContentPdf(filtersImg, clientsImg, ubImg, appealsImg, efficiencyList, emptyEfficiencyList),
                    footer: {
                      columns: [
                        {
                          text: lang.get('report.generated_by'),
                          fontSize: 8,
                          bold: true,
                          alignment: 'right',
                          margin: [0, 0, 20, 0]
                        }
                      ]
                    },
                  };
                  pdfMake.createPdf(docDefinition).download(pdfName + '.pdf');
                  this.$emit('generated', true);
                });
              })
            });
            });
          });
        });
      },

      getContentPdf (filtersImg, clientsImg, ubImg, appealsImg, efficiencyList, emptyEfficiencyList) {
        let content = [];

        content.push({
          image: filtersImg,
          width: 550,
        });

        content.push({
          image: clientsImg,
          width: 570,
          margin: [-10, 20, 0, 0]
        });

        content.push({
          image: ubImg,
          width: 570,
          margin: [-10, 20, 0, 0],
          pageBreak: 'before'
        });

        content.push({
          image: appealsImg,
          width: 570,
          margin: [-10, 20, 0, 0],
          pageBreak: 'before'
        });

        efficiencyList.forEach(function (efficiency) {
          content.push({
            pageBreak: 'before',
            text: lang.get('report.data_protocol') + ': ' + efficiency.title,
            bold: true,
            margin: [-10, 20, 0, 0],
          });
          content.push({
            image: efficiency.source,
            width: 570,
            margin: [-10, 10, 0, 0]
          });
        });

        emptyEfficiencyList.forEach(function (efficiency) {
          content.push({
            pageBreak: 'before',
            text: lang.get('report.data_protocol') + ' ' + efficiency.title,
            bold: true,
            margin: [-10, 10, 0, 0]
          });
          content.push({
            image: EMPTY_APPLYINGEFFICIENCY_IMG.source,
            width: 570,
            margin: [-10, 20, 0, 0]
          });
        });

        return content;
      },

      pix2mm (val, dpi) {
        return (val / 0.0393701) / dpi;
      },
    },

  };
</script>



// WEBPACK FOOTER //
// src/modules/reports/components/PdfReportClient.vue